<template>
  <div style="text-align:center;">
    <table border="1" style="border-bottom:0">
      <!-- 第1行(1表) -->
      <tr style="height:100px">
        <td width="25%" style="padding:0 20px" class="titleSpan companyTitle KaiTi">河南邦泰合力管理咨询有限公司</td>
        <td width="60%" class="titleSpan tableTitle">安 全 评 价 项 目 组 任 命 书</td>
        <td style="border:0" class="titleSpan">BTHL-GK-001</td>
      </tr>
    </table>
    <table border="1">
      <!-- 第2行(2表) -->
      <tr style="height:50px">
        <td width="25%" class="titleSpan">项目名称</td>
        <td colspan="3" class="contentSpan">{{printData.company_name}}</td>
      </tr>
      <!-- 第3行(2表) -->
      <tr style="height:50px">
        <td width="25%" class="titleSpan">委托单位</td>
        <td colspan="3" class="contentSpan">{{printData.company_name}}</td>
      </tr>
      <!-- 第4行(2表) -->
      <tr style="height:50px">
        <td width="25%" class="titleSpan">企业地址</td>
        <td colspan="3" class="contentSpan">{{printData.company_name}}</td>
      </tr>
      <!-- 第5行(2表) -->
      <tr style="height:50px">
        <td width="25%" class="titleSpan">企业联系人</td>
        <td width="20%" class="contentSpan">{{printData.company_name}}</td>
        <td width="20%" class="titleSpan">电话/传真</td>
        <td class="contentSpan">{{printData.company_name}}</td>
      </tr>
      <!-- 第6行(2表) -->
      <tr style="height:50px">
        <td width="25%" class="titleSpan">计划开工日期</td>
        <td width="20%" class="contentSpan">{{printData.start_date}}</td>
        <td width="20%" class="titleSpan">计划完工日期</td>
        <td class="contentSpan">{{printData.end_date}}</td>
      </tr>
      <!-- 第7行(2表) -->
      <tr style="height:50px">
        <td width="25%" class="titleSpan">评价类型</td>
        <td colspan="3">
          <ul class="pjTypeList">
            <li v-for="item in pjTypeList" :key="item.id">
              <div style="padding-top:2px;">
                <img
                  style="width:15px"
                  v-if="item.id ==1"
                  src="../../assets/image/tableSelected_selected.png"
                  alt
                />
                <img
                  style="width:15px"
                  v-else
                  src="../../assets/image/tableSelected_unselected.png"
                  alt
                />
              </div>
              <div style="margin-right:5px">{{item.label}}</div>
            </li>
          </ul>
        </td>
      </tr>
      <!-- 第8行(2表) -->
      <tr style="height:80px">
        <td colspan="4">{{`根据本机构工作计划安排，特任命以下人员为评价组成员，任命${`_______`}担任本次评价组长，要求在规定时间内完成本项目的安全评价工作。`}}</td>
      </tr>
    </table>
    <table border="1" style="border-top:0">
      <!-- 第9行(3表) -->
      <tr style="height:50px">
        <td width="11%" :rowspan="100" class="titleSpan">评价组成员</td>
        <td width="14%" class="titleSpan">姓名</td>
        <td width="23%" class="titleSpan">资质证书编号</td>
        <td width="15%" class="titleSpan">人员专业</td>
        <td class="titleSpan">承担工作</td>
      </tr>
      <tr style="height:50px" v-for="item in 20">
        <td width="14%" class="contentSpan">{{'张三'}}</td>
        <td width="23%" class="contentSpan">A12228871652X1</td>
        <td width="15%" class="contentSpan">专业</td>
        <td class="contentSpan">工作0001</td>
      </tr>
    </table>
    <table border="1" style="border-top:0">
      <!-- 第十二行(4表) -->
      <tr style="height:170px">
        <td colspan="4" style="text-align:left;">
          <div class="pmargin" style="min-height:170px;box-sizing:border-box;padding:5px;">
            <div>企业特殊要求 :</div>
            <div>负责与企业对接，沟通评价相关事宜；</div>
            <div>负责现场勘查，记录现场勘查内容；</div>
            <div>按照要求完成报告的编制和修订工作；</div>
            <div>客观、公正、严谨的编制报告；</div>
            <div>到达企业后，注意自身安全，佩戴劳动防护用品，按照评价企业规章制度开展工作。</div>
          </div>
        </td>
      </tr>
      <!-- 第十三行(4表) -->
      <tr style="height:100px">
        <td colspan="4" style="text-align:left;">
          <div style="min-height:100px;box-sizing:border-box;padding:10px;" class="wirteTableRow">
            <div class="pic">
              <div>总经理签字:</div>
              <img src="../../assets/image/icon_MP4@2x.png" alt />
            </div>
            <div>年月日</div>
          </div>
        </td>
      </tr>
    </table>
  </div>
</template>
<script>
import { mapState, mapGetters, mapMutations } from 'vuex'
export default {
  data() {
    return {
      // 评价类别
      pjTypeList: [
        {
          id: '1',
          label: '预评价',
        },
        {
          id: '2',
          label: '验收评价',
        },
        {
          id: '3',
          label: '现状评价',
        },
        {
          id: '4',
          label: '专项评价',
        },
        {
          id: '5',
          label: '其它',
        },
      ],
    }
  },
  computed: {
    ...mapState('process/projectTable', ['printData']),
  },
  methods: {},
  mounted() {},
  async created() {},
}
</script>
<style lang="less" scoped>
@import url(./printDialog.scss);
</style>